import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { isNativePlatform } from '../utils/device';

const PdfViewer = lazy(() => import('./PdfViewer'));

export default function PdfEmbed({
  blob = null,
  url = '',
  title = 'PDF preview',
  className = '',
  style,
}) {
  const isNative = isNativePlatform();
  const [blobUrl, setBlobUrl] = useState('');

  useEffect(() => {
    if (isNative || !blob) {
      setBlobUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return '';
      });
      return undefined;
    }

    const objectUrl = URL.createObjectURL(blob);
    setBlobUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [isNative, blob]);

  const iframeSrc = url || blobUrl;

  if (isNative) {
    if (!blob && !url) return null;

    return (
      <Suspense
        fallback={(
          <div className="flex min-h-[200px] items-center justify-center text-muted-foreground">
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Loading PDF…
          </div>
        )}
      >
        <PdfViewer blob={blob} url={url} className={className} />
      </Suspense>
    );
  }

  if (!iframeSrc) return null;

  return (
    <iframe
      title={title}
      src={iframeSrc}
      className={className}
      style={style}
    />
  );
}
